export enum ESubscription {
  SERENITE = 'SERENITE',
  LIBERTE = 'LIBERTE',
  COMPTABILITE = 'COMPTABILITE',
}
